import {
  COMPONENT_VALUE_TYPES as types,
} from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

const propsSchema: PropsSchemaList = [
  {
    key: 'general',
    label: 'General',
    type: types.OBJECT,
    children: [
      {
        key: 'backgroundColor',
        label: 'Background Color',
        type: types.COLOR_PICKER
      },
      {
        key: 'showPublishDate',
        label: 'Show publish date instead of relative time (e.g. "Jan 6, 2023" instead of "3 days ago")',
        type: types.BOOLEAN
      }
    ]
  },
  {
    key: 'messages',
    label: 'Social Media Messages',
    type: types.ARRAY,
    children: [
      {
        key: 'asset',
        label: 'Image/Video Asset',
        type: types.S3_ASSET_URL
      },
      {
        key: 'imageAlt',
        label: 'Image Alternative Text (A brief description of the image to optimize search engine visibility)',
        type: types.TEXT
      },
      {
        key: 'url',
        label: 'Target URL',
        type: types.TEXT
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
        options: {
          maxLength: 40
        }
      },
      {
        key: 'text',
        label: 'Text',
        type: types.TEXT,
        options: {
          maxLength: 80
        }
      },
      {
        key: 'avatar',
        label: 'User Avatar Image',
        type: types.S3_ASSET_URL
      },
      {
        key: 'user',
        label: 'User Name',
        type: types.TEXT,
        options: {
          maxLength: 28
        }
      },
      {
        key: 'platform',
        label: 'Social Platform',
        type: types.ICON_SOCIAL
      },
      {
        key: 'timestamp',
        label: 'Message Datetime',
        type: types.DATETIME
      },
    ]
  },
  {
    key: 'loadMore',
    label: 'Enable \'Load More\' button',
    type: types.BOOLEAN
  },
];

// Test Data
const message = {
  title: 'FF 91, Perfect!! | #FF 91 Performance',
  url: 'https://genesis-cdn.ff.com/faraday-future-ff-91/faraday-future-ff-91-eminence-hero-image.jpg',
  imageAlt: '',
  text: 'Racing 2000m above sea level as we head to Mexico City for this year\'s #F1ESTA 🥳 Adding more text here to cross two lines',
  avatar: 'https://genesis-cdn.ff.com/faraday-future-ff-91/faraday-future-ff-91-eminence-hero-image.jpg',
  platform: 'ff-icon-social-twitter',
  timestamp: {
    date: '2023-01-06T22:00:00.000Z',
    timezone: 'America/Los_Angeles'
  },
  user: 'Mute Worker(@Mute Worker)'
};
const assetBig = 'https://genesis-cdn.ff.com/Product_App/Image/responsive/Welcome_to_the_Future_of_Mobility-800w.jpg';
const assetSmall = 'https://genesis-cdn.ff.com/faraday-future-ff-91/faraday-future-ff-91-eminence-hero-image.jpg';

const defaultProps = {
  general: {
    backgroundColor: '#2D2F34',
    showPublishDate: false
  },
  messages: [
    { ...message, asset: assetBig },
    { ...message, asset: assetSmall },
    { ...message },
    { ...message, asset: assetSmall },
    { ...message, asset: assetSmall },
    { ...message, asset: assetBig },
    { ...message, asset: assetSmall },
    { ...message, asset: assetSmall },
    { ...message, asset: assetBig },
    { ...message, asset: assetSmall },
    { ...message },
    { ...message, asset: assetSmall },
    { ...message, asset: assetSmall },
    { ...message, asset: assetBig },
    { ...message, asset: assetSmall },
    { ...message, asset: assetSmall },
  ],
  loadMore: true
};

export default {
  title: 'Social Media Message Layout',
  id: 'SocialMediaMessageLayout',
  propsSchema,
  defaultProps
};
